import { API } from "../utils/config";
import { getDatabase, ref, onValue } from "firebase/database";

interface InterfacePostDeleteSection {
  id: number;
  id_restaurant: number;
}

interface IntSection {
  id_section: string;
  id_restaurant: string;
}

// restaurant
export const GetDataRestaurant_API = async (id: string) => {
  let data;
  const realtime = getDatabase();
  const starCountRef = ref(realtime, "restaurants/" + id);
  onValue(starCountRef, (snapshot) => {
    if (snapshot.exists()) {
      data = snapshot.val();
    } else {
    }
  });
};

export const GetSectionRestaurant_API = async (id: any) => {
  // return await API.get(`/sections?id_restaurant=${id}`);
  let data;
  const realtime = getDatabase();
  const starCountRef = ref(realtime, "menu-sections/" + id);
  onValue(starCountRef, (snapshot) => {
    data = snapshot.val();
    return data;
  });
};

export const PutEditRestaurant_API = async (token: any, data: any) => {
  return await API.put(`/restaurants`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const GetTodosRestaurants_API = async (token: any) => {
  return await API.get(`/restaurants`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// sections
export const PostCreateSection_API = async (token: any, data: any) => {
  return await API.post(`/sections`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PutEditSection_API = async (token: any, data: any) => {
  return await API.put(`/sections`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PatchPositonsSection = async (token: any, data: any) => {
  return await API.put(`/sections`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PostDeleteSection = async (
  token: any,
  data: InterfacePostDeleteSection
) => {
  return await API.post(
    `/sections-delete`,
    {
      id: data.id,
      id_restaurant: data.id_restaurant,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Items
export const GetItemsRestaurant_API = async (data: IntSection) => {
  return await API.get(
    `/items?id_section=${data.id_section}&id_restaurant=${data.id_restaurant}`
  );
};

export const PostCreateItem_API = async (token: any, data: any) => {
  return await API.post(`/items`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PutEditItem_API = async (token: any, data: any) => {
  return await API.put(`/items`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PatchPositonItem = async (token: any, data: any) => {
  return await API.put(`/items`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const DeleteItem_API = async (token: any, data: any) => {
  return await API.post(`/items-delete`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// utils
export const PostValidateCodeAdmin = async (code: any) => {
  return await API.post(`/validate_code?code=${code}`);
};

// analytics admin
export const PostAnalytic_API = async (data: any, token: any) => {
  return await API.post(`/analytics/admin`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const PostAnalyticsUsers_API = async (data: any, token: any) => {
  return await API.post(`/analytics/users`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// analytics admin
export const PostValidateToken_API = async (data: any) => {
  return await API.post(`/verify/token_user?param=${data}`);
};

export const PostUploadImage_API = async (token: any, data: any) => {
  return await API.post(`/upload_image`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PostAddPremium_API = async (token: any, data: any) => {
  return await API.post(`/add_premium`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const PostChangePassword = async (email: any) => {
  return await API.post(`/reset_password?email=${email}`);
};

export const GetUsersyRestaurant = async (token: any) => {
  return await API.get(`/users_business`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
